import { ApiQueryParams } from '@frontend/api-utils';
import { MultiObjectSelectInput } from '@frontend/components/basic-forms';
import { UserClient } from '@frontend/user/api';
import { IUser, UserListResponse, UserQueryParams } from '@frontend/user/types';
import { User } from '@frontend/user/utils';
import React, { useState } from 'react';

const ID = 'multi-user-select';
export interface MultiUserSelectProps {
    id?: string;
    label?: React.ReactNode;
    required?: boolean;
    onChange?: (newValue: string[]) => void;
    onChangeObject?: (newValue: IUser[]) => void;
    value?: string[];
    searchValueOverwrite?: string;
    className?: string;
    disabled?: boolean;
    isClearable?: boolean;
    allowURLChange?: boolean;
    createEnabled?: boolean;
    queryParams?: ApiQueryParams<UserQueryParams>;
    disableFetch?: boolean;
    subset?: string[];
    onFocus?: React.FocusEventHandler<HTMLInputElement> | undefined;
    onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
    isOpenOverwrite?: boolean;
    queryKeyOverride?: string;
    fetchOverwrite?: (queryParams?: ApiQueryParams<UserQueryParams>) => Promise<UserListResponse>;
    itemLabelOverwrite?: (item: IUser) => string;
}

export const MultiUserSelect = (props: MultiUserSelectProps) => {
    const [v, cV] = useState<IUser[]>([]);
    return (
        <MultiObjectSelectInput<IUser, UserQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            key={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Users'}
            onChange={(v: IUser[]) => {
                props.onChange && props.onChange(v.map((user) => user.id));
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            queryParams={{ ...props.queryParams }}
            value={props.value || v.map((user) => user.id) || []}
            fetch={(arg) => (props.fetchOverwrite ? props.fetchOverwrite(arg) : UserClient.fetchUsers({ ...arg, sort_field: 'name', sort_direction: 'asc' }))}
            multiFetch={(ids) => UserClient.resolveUsers(ids).then((res) => res.results)}
            itemLabel={(user: IUser) => (props.itemLabelOverwrite ? props.itemLabelOverwrite(user) : new User(user).getDisplayName())}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: props.queryKeyOverride ?? 'user_id',
                          fetch: (id) =>
                              UserClient.resolveUsers(id).then((res) => {
                                  return res.results;
                              })
                      }
                    : undefined
            }
        />
    );
};
